import {
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

export function ConfirmModal({
  title = "확인",
  description,
  confirmText = "확인",
  cancelText = "취소",
  close = (result) => {
    return result.action === "confirm";
  },
}) {
  return (
    <div className="space-y-6">
      <DialogHeader>
        <DialogTitle>{title}</DialogTitle>
        <DialogDescription>{description}</DialogDescription>
      </DialogHeader>
      <DialogFooter className="flex justify-end gap-2">
        <Button variant="outline" onClick={() => close({ action: "cancel" })}>
          {cancelText}
        </Button>
        <Button onClick={() => close({ action: "confirm" })}>
          {confirmText}
        </Button>
      </DialogFooter>
    </div>
  );
}
